import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ServicoFormatacao {
  formatarCpf(cpf?: string) {
    const digitos = this.apenasNumeros(cpf || '').slice(0, 11);
    return digitos
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
  }

  apenasNumeros(valor: string) {
    return (valor || '').replace(/\D/g, '');
  }

  normalizarBusca(valor: string) {
    return valor
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();
  }

  formatarHoraCompleta(dataHora: string) {
    return new Date(dataHora).toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  formatarInstantePonto(dataHora?: string) {
    const data = dataHora ? new Date(dataHora) : new Date();
    if (Number.isNaN(data.getTime())) {
      return '';
    }
    const dia = data.toLocaleDateString('pt-BR');
    const hora = data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
    return `${dia} ${hora}`;
  }

  formatarHoraMinuto(dataHora: string) {
    return new Date(dataHora).toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatarDataExtenso(data: Date) {
    return data.toLocaleDateString('pt-BR', {
      weekday: 'long',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  formatarDataIso(valor?: string) {
    const partes = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor || '');
    return partes ? `${partes[3]}/${partes[2]}/${partes[1]}` : (valor || '');
  }

  dataParaIsoLocal(data: Date) {
    const ano = data.getFullYear();
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const dia = String(data.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }
}
